window.addEventListener('load', () => {
    WebFont.load({
        google: {
            families: [ 'Roboto:400,600:latin-ext' ]
        }
    });
});